module.exports = __webpack_public_path__ + "media/images/flags/64/Georgia-b58749aea12f6cf5f589af1524aad0e9.png";